import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/react';

/**
 * Rota que exige sessão no Clerk. Sem sessão confirmada, manda pro /login; enquanto o
 * Clerk ainda carrega, deixa passar — o loader inicial do App cobre esse intervalo.
 */
export default function AuthGuard({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  if (isLoaded && !isSignedIn) return <Navigate to="/login" replace />;
  return children;
}
